class Header {
  constructor(el) {
    this.el = el;
    if ($('.' + this.el).length > 0) {
      this.bindScroll();
    }
  }

  bindScroll() {
    let scrollTimer;
    const update = () => {
      if ($(window).scrollTop() > 100) {
        $('html').addClass('is-scroll');
      } else {
        $('html').removeClass('is-scroll');
      }
    };
    $(window).on('scroll', () => {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(update, 100);
    });
    update();
  }
}

new Header('js-header');
